import { hasExternalRewards } from '@/reducers/programsNew'
import { useAppSelector } from '@/hooks'
import { useParams } from 'react-router-dom'

function useExternalPayoutCheck(utilityProgramIdOverride?: number) {
  const { id: utilityProgramIdParam } = useParams<{ id: string }>()
  const idFromParams =
    utilityProgramIdParam !== undefined
      ? parseInt(utilityProgramIdParam)
      : undefined
  const utilityProgramId = utilityProgramIdOverride ?? idFromParams
  const isExternalReward = useAppSelector(
    hasExternalRewards(utilityProgramId ?? 0),
  )
  return isExternalReward
}

const RewardHelpers = {
  useExternalPayoutCheck,
}

export default RewardHelpers
